/* W93 (his word, 2026-09-28): "some switch somewhere on top which will save its last state for all future reviews of all
 * clients, of play all videos muted (the client's ones)". ONE per-viewer preference — the browser's own storage, never the
 * database: it is how THIS coach likes to watch, not a fact about anybody's training. Default OFF (sound on), the same
 * default the phone's "play muted" switch carries (his 2026-09-12 decision).
 *
 * Storage can be refused (a private window, blocked site data): every read and write is guarded, and a refused read is
 * the default rather than an error — the switch still works for the page, it just is not remembered. */

export const CLIPS_MUTED_KEY = "ht.review.clipsMuted";

const listeners = new Set<() => void>();
let memory: boolean | null = null;

/** The stored answer: `"1"` muted, anything else (absent included) sound on. */
export function parseMuted(raw: string | null): boolean {
  return raw === "1";
}

export function clipsMuted(): boolean {
  if (memory !== null) return memory;
  try { memory = parseMuted(window.localStorage.getItem(CLIPS_MUTED_KEY)); } catch { memory = false; }
  return memory;
}

export function setClipsMuted(muted: boolean): void {
  memory = muted;
  try { window.localStorage.setItem(CLIPS_MUTED_KEY, muted ? "1" : "0"); } catch { /* remembered for this page only */ }
  for (const l of listeners) l();
}

export function subscribeClipsMuted(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
